import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import getFolderTable from '../../selectors/getFolderTable';
import type { MailFolder } from 'owa-graph-schema';

/**
 * Creates the Folder by adding client specific properties
 *
 * @param rawFolder Folder object
 */
export function createOrGetFolder(rawFolder: MailFolder): MailFolder {
    const folder = getFolderTable().get(rawFolder.id);

    // If the folder already exists in the table, return it
    // If unified inbox, we don't want the cached version since folder's mailboxInfos may differ
    // and we want to ensure we return the latest version with correct mailboxInfo
    if (folder && !isUnifiedInboxMailboxInfo(folder.mailboxInfo)) {
        return folder;
    }

    return {
        childFolderIds: [],
        ...rawFolder,
    };
}
